function ShelfSkeleton() {
  return (
    <div className='flex size-full items-center justify-center p-5'>
      <div
        style={{ aspectRatio: 0.5 }}
        className='h-full animate-pulse rounded-lg border-2 border-gray-300 bg-gray-100'
      >
        {/* Simulated shelf layers */}
        <div className="flex size-full flex-col gap-1">
          <div className="flex-1 rounded-sm bg-gray-300" />
          <div className="flex-1 rounded-sm bg-gray-300" />
          <div className="flex-1 rounded-sm bg-gray-300" />
          <div className="flex-1 rounded-sm bg-gray-300" />
          <div className="flex-1 rounded-sm bg-gray-300" />
          <div className="flex-1 rounded-sm bg-gray-300" />
          <div className="flex-1 rounded-sm bg-gray-300" />
        </div>
      </div>
    </div>
  )
}

export default ShelfSkeleton

